import type { MemoizedFunction } from 'lodash';
import memoize from 'lodash/memoize';

import {
	GREY_META,
	OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT as OPTION_COLOR_THEMES_COLORFUL_LABELS,
} from './constants';
import { getHashValueForText } from './getHashValueForText';
import { getRandomIndex } from './getRandomIndex';

export const getAutoGeneratedColorForLabels = (option: string | undefined | null): string => {
	if (option) {
		const hashValue = getHashValueForText(option);

		const randomIndex = getRandomIndex(hashValue);

		return OPTION_COLOR_THEMES_COLORFUL_LABELS[randomIndex].name;
	}
	return GREY_META.name;
};

export const getAutoGeneratedColorForLabelsTag = (option: string): string | undefined => {
	if (option) {
		const hashValue = getHashValueForText(option);

		const randomIndex = getRandomIndex(hashValue);

		return OPTION_COLOR_THEMES_COLORFUL_LABELS[randomIndex].tagColor;
	}
	return GREY_META.tagColor;
};

export const memoizeGetAutoGeneratedColorForLabels: ((
	option: string | undefined | null,
) => string) &
	MemoizedFunction = memoize(getAutoGeneratedColorForLabels);

export const memoizeGetAutoGeneratedColorForLabelsTag: ((option: string) => string | undefined) &
	MemoizedFunction = memoize(getAutoGeneratedColorForLabelsTag);
